import { render, staticRenderFns } from "./changeclass.vue?vue&type=template&id=2699b752&scoped=true"
import script from "./changeclass.vue?vue&type=script&lang=js"
export * from "./changeclass.vue?vue&type=script&lang=js"
import style0 from "./changeclass.vue?vue&type=style&index=0&id=2699b752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2699b752",
  null
  
)

export default component.exports